module.exports = __webpack_public_path__ + "img/sankaku_60_red.192b6571.png";